<template>
  <div
    class="c-profiles-avatar"
    :style="[avatarStyle]"
    @click.prevent="action"
  >
    <span
      v-if="showDefaultIcon"
      class="c-profiles-avatar__default-symbol"
    >
      ...
    </span>
    <span v-else>
      {{ avatarLetter }}
    </span>
    <span
      v-if="edit"
      class="c-profiles-avatar__icon-edit icon-edit"
    ></span>
  </div>
</template>
<script>
  export default {
    props: {
      profile: Object,
      edit: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      avatarStyle() {
        if (this.avatarUrl) {
          return { 'background-image': `url(${this.avatarUrl})` };
        }

        return this.profile && this.profile.color
          ? { 'background-color': this.profile.color }
          : {};
      },
      avatarLetter() {
        if (this.avatarUrl) {
          return '';
        }

        const profile = this.profile;

        return (profile && profile.name && profile.name.charAt(0).toLocaleUpperCase()) || '';
      },
      avatarUrl() {
        if (this.profile && this.profile.avatar && this.profile.avatar.url) {
          return this.profile.avatar.url;
        }
      },
      showDefaultIcon() {
        return !Object.keys(this.avatarStyle).length && this.avatarLetter === '';
      },
    },
    methods: {
      action() {
        this.$emit('action');
      },
    },
  };
</script>
